export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#3E008E',
    contrastText: '#FFFFFF',
    light: 'rgba(233, 248, 255, 1)',
  },
  secondary: {
    main: '#6533A5',
    contrastText: '#668E4D',
  },
  text: {
    primary: '#0F0F0F',
    primaryLight: '#697883',
    light: '#616F83',
    secondary: '#5A6D8E',
    tertiary: '#3E008E',
    description: '#000000',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  borderColor: 'rgba(247, 248, 248, 0.50)',
  background: {
    main: '#190039',
    dark: 'rgba(1, 104, 139, 1)',
    header: '#0D0921',
    light: 'rgba(247, 248, 248, 1)',
    description: '#0C001C',
    ribbon: '#52ACFF',
    paper: '#FFF',
    default: '#FFF',
    footer: '#BCE194',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#3E008E',
    tableSubhead: '#F7F7F7',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#0D0921',
    primary: '#0D0921',
    primaryLight: 'rgba(233, 248, 255, 1)',
    secondaryLight: '#3E008E',
    staticFooter: '#EEF2F6',
    contactBanner: '#EEF2F6',
  },
  verticalBar: {
    used: 'rgba(1, 26, 48, 1)',
    unused: 'rgba(233, 248, 255, 1)',
    unlimited: '#C0C0C0',
  }
};
